<template>
	<div>
		<section>
			<div class="inner row5">
				<div class="title">
					<h1>설문관리</h1>
				</div>
				<section>
					<div class="row4">
						<div class="topContent flex">
							<div class="left flex">
								<p>총 <span>{{ totalCnt }}</span>건</p>
								<p>현재 페이지 {{ currentPage }} / {{ totalPage }}</p>
							</div>
							<div>
								<input type="text" class="searchInput" v-model="searchText" @keyup.enter="onClickSearch"/>
								<input type="button" value="검 색" class="searchBtn searchBtnCmmn" @click="onClickSearch"/>
								<input type="button" value="검색초기화" class="searchResetBtn searchBtnCmmn" @click="onClickReset"/>
								<div class="btnBox blankLeft inlineB">
									<button type="button" class="greenBtn smBtn" @click="onClickAdd">등록</button>
									<button type="button" class="orangeBtn smBtn" @click="onClickDelete">삭제</button>
								</div>
							</div>
						</div>
						<div class="tableContainer">
							<div class="sampleTemplate">
										<b-table
										ref="table"
										:fields="fields"
										:items="getItems"
										:per-page="perPage"
										:current-page="currentPage"
										selectable
										@row-selected="onSelectRow"
										@head-clicked="onClickHead"
										hover
										show-empty
										empty-text="해당 설문이 존재하지 않습니다.">
											<template #emptyfiltered="scope">
												<h4>{{ scope.emptyFilteredText }}</h4>
											</template>
											<template #cell(SELECT)="{ rowSelected }">
												<template v-if="rowSelected">
													<span aria-hidden="true">&check;</span>
													<span class="sr-only">Selected</span>
												</template>
												<template v-else>
													<span aria-hidden="true">&nbsp;</span>
													<span class="sr-only">Not selected</span>
												</template>
											</template>

											<template #cell(INDEX)="data">
												{{ data.index + 1 }}
											</template>

											<template #cell(STATUS)="data">
													<span v-html="getStatus(data.item)"></span>
											</template>

											<template #cell(SHOW_DETAIL)="row">
												<b-button size="sm" @click="onClickShowDetail(row)" class="mr-2">
													상세보기
												</b-button>
											</template>

										</b-table>

										<b-pagination
										v-model="currentPage"
										:total-rows="totalCnt"
										:per-page="perPage"
										aria-controls="table">
										</b-pagination>
										
							</div>
							<AdminModalSurvey v-if="isShowModalSurvey" v-bind:surveyIdx='detailSurveyIdx' @modal-closed="handleModalClosed"/>
						</div>
					</div>
				</section>
			</div>
		</section>
	</div>   
</template>

<script>
import {mapActions} from 'vuex'
import {STATUS} from '@/data/survey'
import * as surveyUtil from '@/utils/surveyUtil'
import AdminModalSurvey from '@/components/survey/admin/ModalSurvey'

export default {
	name: 'Home',
	components:{
		AdminModalSurvey
	},
	data() {
		return {
			perPage: 10,
			currentPage: 1,
			totalCnt: 0,
			sortBy: 'IDX',
			sortDesc: false,
			searchText : "",
			fields: [
				{
					// virtual column
					key: 'SELECT',
					label: '선택',
					class: 'text-center',
				},
				{
					// virtual column
					key: 'ROWNUM',
					label: 'No',
					class: 'text-center'
				},
				{
					// virtual column
					key: 'STATUS',
					label: '상태',
					isActive: true,
					class: 'statusOn text-center'
				},
				{
					key: 'TARGET',
					label: '대상',
					isActive: true,
					class: 'statusOn text-center',
					formatter(value){
						switch(value){
							case 'USER': return '개인'
							case 'CORP': return '기업'
							default: return '전체'
						}
					}
				},
				{
					key: 'TITLE',
					label: '설문 제목',
					class: 'text-center max_lengthFix',
					formatter(value){
						if(value.length > 30){
						return value.substring(0,30)+"..."
						}
						else return value
					}
				},
				{
					key: 'INTRODUCTION',
					label: '설문지 설명',
					class: 'text-center max_lengthFix',
					formatter(value){
						if(value) {
						if(value.length > 50){
						return value.substring(0,50)+".."
						}
						else return value
						} else return ''
					}
				},
				{
					key: 'REGDATE',
					label: '등록일',
					class: 'text-center'
				},
				{
					key: 'START_DATE',
					label: '시작일',
					class: 'text-center'
				},
				{
					key: 'END_DATE',
					label: '종료일',
					class: 'text-center'
				},
				{
					// virtual column
					key: 'SHOW_DETAIL',
					label:'상세보기',
					class: 'text-center'
				}
			],
			isShowModalSurvey: false,
			detailSurveyIdx: null, // 등록: null, 수정: survey idx
			selected: []
		}
	},
	computed:{
		totalPage(){
			if(this.totalCnt == 0 ) return 1;
			else if(this.totalCnt % this.perPage == 0) return this.totalCnt/this.perPage;
			else return Math.floor(this.totalCnt/this.perPage) + 1;
		}
	},
	methods:{
		...mapActions('survey', [
			'requestList',
			'deleteSurvey'
		]),
		getItems(){
			return this.requestList({
				currentPage: this.currentPage,
				perPage: this.perPage,
				sortBy: this.sortBy,
				sortDesc: this.sortDesc,
				searchText : this.searchText 
			})
			.then(response => {
        const items = response.data.items
        this.totalCnt = response.data.totalCnt

        return items
			})
			.catch((error) => {
				console.log(error)
				this.$alert("알림", "설문지 조회에 실패했습니다.");
				return []
			})
		},
		getStatus(item){
			var status = surveyUtil.getStatus(item.START_DATE, item.END_DATE)
			switch(status){
				case STATUS.STANDBY:
					return '<span class="notSubmit">대기</span>'
				case STATUS.ONGOING:
					return '진행'
				case STATUS.COMPLETED:
					return '종료'
			}
		},
		onClickShowDetail(row){
			this.detailSurveyIdx = row.item.IDX
			this.isShowModalSurvey = true
		},
		onClickHead(key){
			if(key === 'SELECT'){
				if(this.selected.length == this.totalCnt){
					this.$refs.table.clearSelected()
				}
				else{
					this.$refs.table.selectAllRows()
				}
			}
		},
		onSelectRow(items){
			this.selected = items
		},
		onClickSearch(){
			this.$refs.table.refresh()
		},
		onClickReset(){
			this.perPage = 10;
			this.currentPage = 1;
			this.totalCnt = 0;
			this.sortBy = 'IDX';
			this.sortDesc = false;
			this.searchText = "";
			
			this.$refs.table.refresh()
		},
		onClickAdd(){
			this.detailSurveyIdx = null
			this.isShowModalSurvey = true
		},
		onClickDelete(){
			const selected = this.selected;
			if(selected.length == 0){
				this.$alert("알림", "삭제할 글을 선택해주세요.")
				return
			}

			var response = this.$createConfirmResponse()
      this.$confirm("알림", `${selected.length}개의 항목을 삭제하시겠습니까?`, "확인", "취소", response, {
				'closed': () => {
					if(response.result){
						var surveyIdxList = []
						selected.forEach((item)=>{
							surveyIdxList.push(item.IDX)
						})

						this.deleteSurvey(surveyIdxList)
						.then(response => {
							var data = response.data
							if(data.RESULT == true){
								this.$alert('알림', '삭제가 완료되었습니다.', null, {
									'closed': () => {
										this.$refs.table.refresh()
									}
								})
							}
							else{
								this.$alert('알림', '설문지 삭제에 실패했습니다. ERROR: '+data.ERROR)
							}
						})
						.catch(()=>{
							this.$alert('알림', '데이터 통신을 실패했습니다.')
						})
					}
				}
			});
		},
		handleModalClosed(value, param){
			if(value === AdminModalSurvey.name){
				this.isShowModalSurvey = false

				if(param.result == true){
					this.$refs.table.refresh()
				}
			}
		}
	}
}
</script>

<style scoped lang="scss">
	.sampleTemplate ::v-deep {
		@import "~bootstrap/dist/css/bootstrap.min";
		@import "~bootstrap-vue/dist/bootstrap-vue.min";
	}
</style>